"use strict";

Shopify.theme.jsAkHistory = {
  init: function () {
    function scrollRoot() {
      // Desktop squeeze: .page-wrapper scrolls. Mobile: the document scrolls
      // (address bar hide/show). Using the wrong root leaves scrollTop stuck at 0.
      if (window.matchMedia("(min-width: 990px)").matches) {
        return (
          document.querySelector(".page-wrapper") ||
          document.scrollingElement ||
          document.documentElement
        );
      }
      return document.scrollingElement || document.documentElement;
    }

    function adjustScrollBy(delta) {
      if (Math.abs(delta) < 1) return;
      if (window.matchMedia("(min-width: 990px)").matches) {
        scrollRoot().scrollTop += delta;
        return;
      }
      // Mobile: prefer window so we hit the real scrolling viewport.
      window.scrollBy(0, delta);
    }

    /**
     * Keep a trigger card glued in the viewport while panels open/close so the
     * timeline does not jump when a tall details drawer collapses.
     */
    function withStableScroll($anchor, work) {
      var el = $anchor && $anchor[0];
      if (!el) {
        work();
        return;
      }

      var before = el.getBoundingClientRect().top;

      work();

      // Double rAF: wait for hide/show layout, then correct scroll.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var after = el.getBoundingClientRect().top;
          adjustScrollBy(after - before);

          // Settle the year card into a comfortable band if it landed off-screen.
          var rect = el.getBoundingClientRect();
          var vh = window.innerHeight || 0;
          if (!vh) return;
          var target = Math.round(vh * 0.28);
          if (rect.top < 72 || rect.top > vh * 0.7) {
            adjustScrollBy(rect.top - target);
          }
        });
      });
    }

    function repositionDetails() {
      var mobile = window.matchMedia("(max-width: 798px)").matches;

      $(".history-items-details:visible").each(function () {
        var $details = $(this);
        var $item = $details.closest(".history-items");
        if (!$item.length) return;

        if (mobile) {
          // Pull the full-bleed panel to the viewport left edge. position().left
          // only sees the flex container, so padded pages sat ~16px off-center.
          var shift = $item.offset().left;
          $details.css({
            left: -shift,
            width: window.innerWidth,
            maxWidth: "100vw",
          });
          return;
        }

        var offset = $item.position().left;
        $details.css({
          left: -offset,
          width: "",
          maxWidth: "",
        });
      });
    }

    function closeAllDetails(except) {
      $(".history-items-details")
        .not(except || $())
        .each(function () {
          var $panel = $(this);
          var $slider = $panel.find(".ak-history-slider");
          if ($slider.hasClass("flickity-enabled")) {
            $slider.flickity("destroy");
          }
          // Instant hide avoids a long collapse animation that yanks the page.
          $panel.stop(true, true).hide();
        });

      $(".history-items").removeClass("hovered freeze");
      $(".history-items-grid").removeClass("active");
    }

    function openDetails($trigger) {
      var $item = $trigger.closest(".history-items");
      var $details = $item.find(".history-items-details").first();
      var $slider = $item.find(".ak-history-slider");
      var $grid = $trigger.closest(".history-items-grid");
      var alreadyOpen = $details.is(":visible");

      // Re-clicking the open year closes it in place (stable scroll).
      if (alreadyOpen) {
        withStableScroll($item, function () {
          closeAllDetails();
        });
        return;
      }

      withStableScroll($item, function () {
        closeAllDetails($details);

        // Dim siblings visually only — freeze must not block clicks (pointer-events).
        $item.siblings().addClass("freeze").removeClass("hovered");
        $grid.addClass("active");

        if ($slider.hasClass("flickity-enabled")) {
          $slider.flickity("destroy");
        }

        // Show immediately (no slideDown) so layout settles in one frame.
        $details.stop(true, true).show();
        repositionDetails();

        $slider.flickity({
          cellAlign: "left",
          contain: true,
          pageDots: false,
          adaptiveHeight: true,
          imagesLoaded: true,
          on: {
            ready: function () {
              window.setTimeout(function () {
                $slider.flickity("resize");
                repositionDetails();
              }, 200);
            },
          },
        });
      });
    }

    $(".history-items").hover(
      function () {
        $(this).siblings().addClass("hovered");
      },
      function () {
        $(".history-items").removeClass("hovered");
      }
    );

    $(".history-items-grid .image-element__wrap, .more-link, .year-cta").on(
      "click",
      function (event) {
        event.preventDefault();
        openDetails($(this));
      }
    );

    repositionDetails();

    $(window).on("resize.akHistory", function () {
      repositionDetails();
    });

    $(".close-btn").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var $item = $(this).closest(".history-items");
      withStableScroll($item, function () {
        closeAllDetails();
      });
    });

    // Outside click / Escape closes the More panel without losing place.
    $(document)
      .off("click.akHistoryOutside keydown.akHistoryEscape")
      .on("click.akHistoryOutside", function (event) {
        var $open = $(".history-items-details:visible");
        if (!$open.length) return;
        var $t = $(event.target);
        if ($t.closest(".history-items-details").length) return;
        if ($t.closest(".history-items-grid .image-element__wrap, .more-link, .year-cta").length) {
          return;
        }
        var $item = $open.closest(".history-items");
        withStableScroll($item, function () {
          closeAllDetails();
        });
      })
      .on("keydown.akHistoryEscape", function (event) {
        if (event.key !== "Escape") return;
        var $open = $(".history-items-details:visible");
        if (!$open.length) return;
        var $item = $open.closest(".history-items");
        withStableScroll($item, function () {
          closeAllDetails();
        });
      });
  },
  unload: function () {
    $(".history-items").off();
    $(".history-items-grid .image-element__wrap, .more-link, .year-cta").off("click");
    $(".close-btn").off("click");
    $(document).off("click.akHistoryOutside keydown.akHistoryEscape");
    $(window).off("resize.akHistory");
  },
};
